import styled from 'styled-components'
import { Paper, Select } from '@material-ui/core'
import { colors, theme } from '../Global'

export const NoRecords = styled.div`
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: inherit;
`

export const TableControlsButtonGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  && button {
    margin: 0 1rem;
  }
  && button:first-child {
    margin: 0 1rem 0 0;
  }
`

export const StyledInlineSelect = styled(Select)`
  display: inline-block !important;
  background: ${colors.white};
  border: 1px solid ${colors.darkGrey};
  color: ${theme.colors.text};
  padding: 0.25rem 0;
  width: 100%;
  line-height: 1.7rem !important;
  margin-top: 4px !important;
  > div > div {
    padding-left: 10px;
  }
`

export const StyledPaper = styled(Paper)`
  && {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    padding: 0;
    margin: 0;
    height: auto;
    box-shadow: unset;
  }
`

export const TableContainer = styled(StyledPaper)`
  &&& {
    overflow-x: ${(props) => (props.scrollable ? 'auto' : '')};
    overflow-y: ${(props) => (props.scrollable ? 'auto' : '')};
    height: ${(props) => (props.scrollable ? 'calc(100vh - 290px)' : '')};
    &::-webkit-scrollbar {
      height: 0.5rem;
      width: 0.5rem;
    }

    &::-webkit-scrollbar-track {
      background-color: ${colors.lightGrey};
    }

    &::-webkit-scrollbar-thumb {
      background-color: ${colors.govDocsBlue};
      outline: 1px solid ${colors.govDocsBlue};
      border-radius: 8px;
    }

    &::-webkit-scrollbar-corner {
      background-color: ${colors.lightGrey};
    }
  }
`

export const TableStyle = {
  options: {
    fixedHeader: true,
    fixedFooter: false,
    stripedRows: false,
    showRowHover: false,
    selectable: false,
    multiSelectable: false,
    enableSelectAll: false,
    deselectOnClickaway: true,
    showCheckboxes: false,
    height: '100%',
  },
  table: {},
  header: {},
  row: {},
  cell: {},
}
